import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import { useStylesHed } from '../../../St/comps/UseStyle';
import StocksForm from './customers-form';
import toast, { Toaster } from 'react-hot-toast';
import StocksAppBar from './customers-appBar';
import customerAPI from '../../../api/customer';
import useFormDataCRUD from '../../../components/Hooks/useEDSCURD';
import { defaultCustomer, GetItemFromOptions, payTypes, SyncLocalStorage } from '../../../services/global-services';
import { AppBar, colors, Paper, Tab, Tabs } from '@material-ui/core';
import { insh as inshst } from '../../../Context/InshSt';
import GroupIcon from '@material-ui/icons/Group';
import { useStyleC } from '../../../Fronts/Menues/st/UseStyle';
import { style } from '../../../Fronts/Menues/st/cStyle';
import { useTranslation } from 'react-i18next';
import CustomersSubForm from './customers-sub-data-form';
import { a11yProps, TabsPanel } from '../../bascDatas/Tab1/items/AddItems/ItemsMains';
import i18next from "i18next";
import ImportExcel from '../../bascDatas/Tab1/items/ImportExcel/ImportExcel';
import { uri } from '../../../help/Api';
import axios from 'axios';
import CustomersSearch from './CustomersSearch/CustomersSearch';
import { sto } from '../../../Context/InshData';

export default function Customers(props) {

  const { data, type, fetchURL, isDialog, defaultSalman, Levels } = props;
  const { t } = useTranslation(['translation', 'forms']);
  const [pricesLevels, setPricesLevels] = useState(() => {
    return [{ id: 0, name: "بدون" }, ...Levels ?? []];
  });


  const defaultValues = {
    ...defaultCustomer,
    acc_no: props.newAccount,
    type: type,
    CustandSup: type,
    act: data?.Acts[0],

  };
  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,

  } = useFormDataCRUD(
    customerAPI.create,
    customerAPI.update,
    customerAPI.remove,
    undefined,
    defaultValues,
    null,
    async () => {
      if (isDialog) {
        // await SyncLocalStorage();
      } else fetchURL();
    },
  );


  const title = type == 1 ? t('translation:customer') : t('translation:customer');
  const title1 = type == 1 ? t('translation:cust-add') : t('translation:sup-add');
  const clashd = useStylesHed();
  const classes = useStyleC();
  const styheader =
    { textAlign: 'center', backgroundColor: "#faf1f1", direction: 'rtl' }
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [excelData, setExcelData] = useState([]);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const getFormExcelData = async () => {
    setLoadingExcel(true);
    const excelCustomers = excelData.map((sub, i) => {
      return {
        name: sub.الاسم !== null ? sub?.الاسم : null,
        tax_no: sub.الضريبة !== null ? sub?.الضريبة : null,
        phone: sub.الجوال !== null ? sub?.الجوال : null,
        address: sub.العنوان !== null ? sub?.العنوان : null,
        build: sub.المبنى !== null ? sub?.المبنى : null,
        add: sub.الإضافي !== null ? sub?.الإضافي : null,
        dist: sub.الحي !== null ? sub?.الحي : null,
        city: sub.المدينة !== null ? sub?.المدينة : null,
        cr_no: sub.السجل !== null ? sub?.السجل : null,
        streat: sub.الشارع !== null ? sub?.الشارع : null,
        credit: sub.الدين !== null ? sub?.الدين : null,
        type: type

      };
    });
    const model = {
      excelCust: excelCustomers,
      type: type,
      db_name: sto?.db_name,
    };
    axios
      .post(uri + "Groups/addExcelCustomers", model)
      .then((res) => {
        setExcelData([]);
        setLoadingExcel(false);
        setValue(0);
        toast.success("تمت عملية  بنجاح");
      })
      .catch((error) => {
        console.log(error);
        setLoadingExcel(false);
        toast.error("خطا في عملية الحفظ");
      });
  };

  //---------------------
  const [transition, setTransition] = React.useState(undefined);
  const [isInternal, setIsInternal] = useState(true);
  const handCloseDw = () => {

    setOpenSearchMdl(false);
  };

  const [openSearchMdl, setOpenSearchMdl] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);

  const onRowClick = (row) => {
    onShow({
      ...row,
      act: GetItemFromOptions(row.act, data?.Acts),
      Cust_inv_type: row?.Cust_inv_type ? GetItemFromOptions(row.Cust_inv_type, payTypes) : payTypes[0],
      salesmen: (row.salesmen && row.salesmen != 0) ? GetItemFromOptions(row.salesmen, data?.salesmen) : '',
      country: GetItemFromOptions(row.country, data?.Countries),
      city: GetItemFromOptions(row.city, data?.Cities),
      area: GetItemFromOptions(row.area, data?.Areas),
      level_price: GetItemFromOptions(row?.level_price ?? 0, pricesLevels),
    }, "edit");
    setValue(0);
  }

  return (
    <div className={classes.root}>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Grid
          container
          justifyContent="center"
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Grid item lg={12} md={12} sm={12} xs={12} >
            <div style={{ backgroundColor: "fff" }}>
              <AppBar position="static" style={{ backgroundColor: "fff" }} >
                <Tabs
                  style={{ backgroundColor: colors.red[100] }}
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab style={{ fontWeight: "bold", color: "#000" }} label={
                    formType == 'edit' ? (type == 1 ? t('forms:edit_cust_data') : t('forms:edit_supplier_data')) : title1
                  }{...a11yProps(0)} />
                  <Tab style={{ fontWeight: "bold", color: "#000" }} label="بحث"{...a11yProps(1)} />
                  <Tab style={{ fontWeight: "bold", color: "#000" }} label="استيراد من اكسل"{...a11yProps(2)} />
                </Tabs>
              </AppBar>

              <TabsPanel value={value} index={0}>

                <Typography component="div" style={styheader}>
                  <Grid item container style={{ paddingBottom: "50px" }}>
                    <Grid container
                      justifyContent="space-around"
                    >
                      <Grid item lg={8} md={8} sm={12}>
                        <Container component={Paper} maxWidth={true}
                          style={{
                            padding: '15px',
                            // paddingRight:'0px',
                            // backgroundColor: colors.[50],
                            paddingTop: '0px',
                            borderColor: inshst.colors.cust,
                            borderTopWidth: '0px',
                            borderLeftWidth: '0px',
                            borderBottomWidth: '0px',
                            borderRightWidth: '10px',
                            borderStyle: 'solid'
                          }}

                        >
                          <Grid
                            container
                            justify="space-between"
                          >
                            <Grid item>
                              <Chip size="large" className={clashd.ChipHdCustomer} label={type == 1 ? t('forms:cust-data') : t('forms:sup-data')} />
                            </Grid>
                            <Grid item>
                              <GroupIcon className={classes.iconCard} style={style.color.customer} />
                            </Grid>
                          </Grid>

                          <StocksForm {...{
                            ...props,
                            onChange,
                            submit,
                            update,
                            remove,
                            submitting,
                            errorMessage,
                            onShow,
                            onEnd,
                            object,
                            formType,
                            type,
                            pricesLevels
                          }} />

                        </Container>
                      </Grid>

                      <Grid item lg={3} md={3} sm={12}>
                        <Container component={Paper} maxWidth={true}
                          style={{
                            padding: '10px',
                            paddingTop: '0px',
                            borderColor: inshst.colors.cust,
                            borderTopWidth: '0px',
                            borderLeftWidth: '0px',
                            borderBottomWidth: '0px',
                            borderRightWidth: '0px',
                            borderStyle: 'solid'
                          }}
                        >
                          <Grid
                            container
                            justify="center"
                            style={{ paddingBottom: '20px' }}
                          >
                            <Grid item>
                              <Chip size="large" className={clashd.ChipHdCustomer} label={"بيانات العنوان الوطني"} />
                            </Grid>
                          </Grid>

                          <CustomersSubForm {...{
                            ...props,
                            onChange,
                            submit,
                            update,
                            remove,
                            submitting,
                            errorMessage,
                            onShow,
                            onEnd,
                            object,
                            formType,
                          }} />

                        </Container>
                      </Grid>
                    </Grid>
                  </Grid>

                </Typography>


              </TabsPanel>
              <TabsPanel value={value} index={1}>
                <b>استيراد من اكسل</b>
                <CustomersSearch
                  openSearchMdl={openSearchMdl}
                  handCloseDw={handCloseDw}
                  onRowClick={onRowClick}
                  type={type}
                  optionsUsers={props?.OptionsUsers}
                  transition={transition}
                  dataSearch={dataSearch}
                  setDataSearch={setDataSearch} />
              </TabsPanel>
              <TabsPanel value={value} index={2}>
                <b>استيراد من اكسل</b>
                <ImportExcel
                  {...{
                    isPurches: false,
                    isStock: false,
                    isItem: true,
                    getFormExcelData,
                    excelData,
                    setExcelData,
                    loadingExcel,
                    setValue
                  }}
                />
              </TabsPanel>
            </div>
          </Grid>
        </Grid>
        <StocksAppBar {...{
          ...props,
          onChange,
          defaultValues,
          submit,
          update,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          pricesLevels
        }} />
      </Typography>
    </div>
  );


}